import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

const catalogTile = (x, y) => (
  <g key={`${x}-${y}`}>
    <rect x={x} y={y} width="72" height="56" fill="#E6E6E6" />
    <rect x={x} y={y + 62} width="64" height="2" fill="#C2C2C2" />
    <rect x={x} y={y + 68} width="46" height="2" fill="#CFCFCF" />
    <rect x={x} y={y + 74} width="30" height="2" fill="#CFCFCF" />
    <rect x={x + 60} y={y + 84} width="10" height="10" fill="#D4D4D4" />
  </g>
);

const ExportOptionModal = ({ open, onClose, onExport, loading = false }) => {
  const { t } = useTranslation();
  const [choice, setChoice] = useState("");

  useEffect(() => {
    if (open) setChoice("");
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="inv-export-option" onMouseDown={onClose}>
      <div
        className="inv-export-option-card"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h2>{t("Export Option")}</h2>
        <p>{t("select your template option to export")}</p>
        <div className="inv-export-option-choices">
          <button
            type="button"
            className={choice === "catalog" ? "is-selected" : ""}
            onClick={() => setChoice("catalog")}
          >
            <span className="inv-export-option-label">{t("Catalog")}</span>
            <span className="inv-export-option-sheet inv-export-option-sheet--catalog" aria-hidden="true">
              <svg viewBox="0 0 168 206" preserveAspectRatio="xMidYMid meet">
                {catalogTile(8, 6)}
                {catalogTile(88, 6)}
                {catalogTile(8, 108)}
                {catalogTile(88, 108)}
              </svg>
            </span>
          </button>
          <button
            type="button"
            className={choice === "detail" ? "is-selected" : ""}
            onClick={() => setChoice("detail")}
          >
            <span className="inv-export-option-label">{t("Detail")}</span>
            <span className="inv-export-option-sheet inv-export-option-sheet--detail" aria-hidden="true">
              <svg viewBox="0 0 168 206" preserveAspectRatio="xMidYMid meet">
                <rect x="78" y="6" width="8" height="6" fill="#D2D2D2" />
                <rect x="66" y="14" width="32" height="2" fill="#D8D8D8" />
                <rect x="146" y="6" width="16" height="2" fill="#C8C8C8" />
                <rect x="152" y="11" width="10" height="2" fill="#C8C8C8" />
                <rect x="48" y="24" width="72" height="5" fill="#E4E4E4" />
                <rect x="8" y="38" width="78" height="68" fill="#E7E7E7" />
                <rect x="92" y="40" width="68" height="3" fill="#B7B7B7" />
                <rect x="92" y="48" width="54" height="2" fill="#C8C8C8" />
                <rect x="92" y="54" width="42" height="2" fill="#C8C8C8" />
                <rect x="92" y="60" width="32" height="2" fill="#C8C8C8" />
                <rect x="92" y="66" width="22" height="2" fill="#C8C8C8" />
                <rect x="140" y="48" width="22" height="2" fill="#D4D4D4" />
                <rect x="140" y="54" width="18" height="2" fill="#D4D4D4" />
                <rect x="140" y="60" width="14" height="2" fill="#D4D4D4" />
                <rect x="146" y="70" width="16" height="2" fill="#D4D4D4" />
                <rect x="8" y="114" width="14" height="14" fill="#E7E7E7" />
                <rect x="28" y="120" width="36" height="2" fill="#CFCFCF" />
                <rect x="92" y="116" width="28" height="2" fill="#D4D4D4" />
                <rect x="140" y="116" width="16" height="2" fill="#D4D4D4" />
                <rect x="8" y="140" width="152" height="58" fill="none" stroke="#E3E3E3" />
                <rect x="8" y="140" width="152" height="12" fill="#E6E6E6" />
                <line x1="8" y1="164" x2="160" y2="164" stroke="#ECECEC" />
                <line x1="8" y1="180" x2="160" y2="180" stroke="#ECECEC" />
                <line x1="8" y1="196" x2="160" y2="196" stroke="#E3E3E3" />
                <line x1="62" y1="152" x2="62" y2="198" stroke="#ECECEC" />
                <line x1="96" y1="152" x2="96" y2="198" stroke="#ECECEC" />
                <line x1="128" y1="152" x2="128" y2="198" stroke="#ECECEC" />
                {[168, 184].flatMap((row) =>
                  [16, 70, 104, 136].map((col) => (
                    <rect key={`${row}-${col}`} x={col} y={row} width="18" height="2" fill="#D5D5D5" />
                  )),
                )}
                {[16, 70, 104, 136].map((col) => (
                  <rect key={`last-${col}`} x={col} y="188" width="14" height="2" fill="#D5D5D5" />
                ))}
              </svg>
            </span>
          </button>
        </div>
        <button
          type="button"
          className="inv-export-option-submit"
          disabled={!choice || loading}
          onClick={() => {
            if (!choice || loading) return;
            onClose();
            onExport(choice);
          }}
        >
          {t("Export")}
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default ExportOptionModal;
